import moment from "moment";
import { indexDetails, indiceFutures, worldIndicesData } from "../../apis";
import { getAssetExchangeNameFromMktSegId, getDecimalLocatorFromApiExchangeName, getDecryptLocalStorage, getStorageWithMultiTabCheck, getDynamicParamsForToFixed, getExchangeName, getMappedMktSegIdFromApiExchangeName, getMktSegIdFromApiExchangeName, getMktSegIdFromMappedMktSegId, isMktDataAllowed, setEncryptLocalStorage, setStorageWithMultiTabCheck } from "../../utils/global_functions";
import { BUSINESS_LAYER_RESPONSE, DEFAULT_FAVOURITE_INDICES, LOCAL_STORAGE_KEYS } from "../../utils/global_variables";

//Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices   --Start
async function _getIndices(userId, objLoginSession) {
    try {
        //Ameersha N - This will add favourities of NIFTY50 and SENSEX on load to favourities
        const defaultFavourites = JSON.parse(getStorageWithMultiTabCheck(`${LOCAL_STORAGE_KEYS.INDICES_FAVOURITE}_${userId}`)) || [];
        const objResp = await indexDetails();
        const data = objResp?.data?.result;
        let FilteredData = [];
        await data?.forEach(element => {
            let abc = isMktDataAllowed(getMktSegIdFromMappedMktSegId(element?.nMarketSegmentId), objLoginSession);
            if (abc) {
                FilteredData?.push(element);
            }
        });
        const addFavourites = FilteredData?.map((item) => {

            //Prachi Tawde 01-08-2023 BT-104813 Breeze - Dashboard - Indices - Start
            const seg_token = `${getMktSegIdFromMappedMktSegId(item?.nMarketSegmentId)}_${item?.nToken}`;
            if (DEFAULT_FAVOURITE_INDICES.includes(seg_token)) {
                const index = defaultFavourites.findIndex(fav => `${fav?.nMarketSegmentId}_${fav?.nToken}` === seg_token);
                if (index === -1) {
                    defaultFavourites.push({
                        ...item,
                        isFavourite: false,
                        LTP: '0',
                        netChange: '0',
                        netChangeIndicator: '0',
                        lastTradeTime: '0',
                        exchangeName: getExchangeName(getMktSegIdFromMappedMktSegId(item?.nMarketSegmentId)),
                        nMarketSegmentId: getMktSegIdFromMappedMktSegId(item?.nMarketSegmentId)
                    });
                } else { }
            } else { }
            setStorageWithMultiTabCheck(`${LOCAL_STORAGE_KEYS.INDICES_FAVOURITE}_${userId}`, JSON.stringify(defaultFavourites));
            //Prachi Tawde 01-08-2023 BT-104813 Breeze - Dashboard - Indices - End
            return {
                ...item,
                isFavourite: false,
                LTP: '0',
                netChange: '0',
                lastTradeTime: '0',
                netChangeIndicator: '0',
                exchangeName: getExchangeName(getMktSegIdFromMappedMktSegId(item?.nMarketSegmentId)),
                nMarketSegmentId: getMktSegIdFromMappedMktSegId(item?.nMarketSegmentId)
            };
        });

        return { status: true, message: null, data: { local: addFavourites, favourites: defaultFavourites } };

    } catch (error) {

        console.log("error", error);

        if (error?.response?.data) {
            return { status: false, message: null, data: error?.response?.data };

        } else {
            return { status: false, message: null, data: {} };

        }
    }
};
//Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices   --End


async function _getWorldIndicesData() {
    try {
        //Vaibhav Singh: 22-12-23: BT-104813: changed filter settings: Start
        const objResp = await worldIndicesData();
        const arrWorldIndices = objResp?.data?.ResponseObject?.resultset.map((worldIndices) => (
            {
                IndexID: worldIndices.IndexID,
                sIndexDesc: worldIndices.IndexName,
                LTP: worldIndices.ClosePrice,
                netChange: worldIndices.Change?.slice(0, 1) !== '+' && worldIndices.Change?.slice(0, 1) !== '-' ? `+${worldIndices.Change.replaceAll(',', '')}` : worldIndices.Change.replaceAll(',', ''), //Prachi T - 22-11-2023 :- BT-104813 -- Dashboard Indices
                netChangeIndicator: worldIndices.PercentageChange?.slice(0, 1) !== '+' && worldIndices.PercentageChange?.slice(0, 1) !== '-' ? `+${worldIndices.PercentageChange}` : worldIndices.PercentageChange,
                lastTradeTime: worldIndices.Date,
                country: worldIndices.IndexCountry

            }));
        //Vaibhav Singh: 22-12-23: BT-104813: changed filter settings: End

        return { status: true, message: null, data: arrWorldIndices };

    } catch (error) {

        if (error?.response?.data) {
            return { status: false, message: null, data: error?.response?.data };

        } else {
            return { status: false, message: null, data: {} };

        }
    }

};

//Prachi Tawde 02-08-2023 BT-104813 Breeze - Dashboard - Indices - Start
async function _getIndiceFutureData(arrWhatsHotData, payload) {
    try {
        const objResp = await indiceFutures(payload);
        const arrFutureTabData = await objResp?.data?.result?.hits?.hits?.map((item) => item?._source).map((item) => ({
            ...item,
            nAssetMktId: getMktSegIdFromApiExchangeName(getAssetExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(item.nMarketSegmentId))), nMktIDForDontmiss: getMappedMktSegIdFromApiExchangeName(item.ExchangeSegment), decimalLocatorLength: getDynamicParamsForToFixed(item?.ExchangeSegment), DecimalLocator: getDecimalLocatorFromApiExchangeName(item?.ExchangeSegment), expiry: moment(item?.nExpiryDate1)?.format('D MMM\'YY')?.toUpperCase()
        }));

        const arrFutureDataWithotSpread = arrFutureTabData?.filter((item) => item.nSpread === 0);
        for (let FutureData of arrFutureDataWithotSpread) {
            const dontMiss = arrWhatsHotData?.find((hotData) => hotData?.mktid === FutureData?.nMktIDForDontmiss && hotData?.token === FutureData?.nToken);
            if (dontMiss) {
                FutureData.dontMiss = [{ event: dontMiss?.event, color: dontMiss?.class, bg_color: dontMiss?.class2 }];
            }
        }
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: arrFutureDataWithotSpread };
    } catch (error) {
        console.log('error', error);
        if (error?.response?.data) {
            return { status: false, message: null, data: error?.response?.data };

        } else {
            return { status: false, message: null, data: [] };

        }
    }
}
//Prachi Tawde 02-08-2023 BT-104813 Breeze - Dashboard - Indices - End

export { _getIndices, _getWorldIndicesData, _getIndiceFutureData };